export interface IMediaStreamTrackAudioSourceOptions {
    mediaStreamTrack: MediaStreamTrack;
}
